import { Link } from "@/components/app/localized-link";
import { Button } from "../ui/button";

export function NotFound({ children }: { children?: any }) {
  return (
    <div className="space-y-2 p-2">
      <div className="text-muted-foreground dark:text-muted-foreground">
        {children || <p>The page you are looking for does not exist.</p>}
      </div>
      <p className="flex items-center gap-2 flex-wrap">
        <Button
          onClick={() => window.history.back()}
          className="bg-emerald-500 text-foreground px-2 py-1 rounded uppercase font-black text-sm"
        >
          Go back
        </Button>
        <Link
          to="/{-$locale}"
          className="bg-cyan-600 text-foreground px-2 py-1 rounded uppercase font-black text-sm"
        >
          Start Over
        </Link>
      </p>
    </div>
  );
}
